export default {
  computed: {
    activeGroups() {
      return this.$store.getters.activeGroups;
    },
    algorithms() {
      return this.$store.getters.org.algorithmConfig.algorithms;
    },
    isOrgLevelAdmin() {
      return (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('admin') !== -1);
    },
    wordspottingGroups() {
      return (this.isOrgLevelAdmin) ?
        this.$store.getters.groups :
        this.managedGroups;
    },
    isGroupManager() {
      return this.managedGroups.length > 0 ||
        (this.$store.getters.org && this.$store.getters.org.roles.indexOf('manager') !== -1);
    },
    groupDefaultList: {
      cache: false,
      get() {
        const defaultAlgo = this.$store.getters.org.algorithmConfig.default_algorithm;
        if (defaultAlgo in this.wordspotting.org && this.wordspotting.org[defaultAlgo].words) {
          return this.wordspotting.org[defaultAlgo].words;
        }
        return this.wordspotting.global[defaultAlgo].words;
      }
    },
    managedGroups() {
      return this._.filter(this.$store.getters.activeGroups, group => {
        return this._.includes(group.roles, 'manager');
      });
    },
    speakerGroups() {
      return this._.filter(this.$store.getters.activeGroups, group => {
        return this._.includes(group.roles, 'speaker');
      });
    },
    showAddNewWordspotting: {
      cache: false,
      get() {
        // We always show the button if there are multiple algos for the org
        if (this.algorithms.length > 1) return true;
        let showForUser = false;
        let showForOrg = false;
        let showForGroups = false;

        if (this.activeWordspotting.indexOf('users') !== -1 && !this.showUserSettings) {
          showForUser = true;
        }
        if (this.activeWordspotting.indexOf('org') !== -1 && !this.showOrgSettings) {
          showForOrg = true;
        }
        if (this.activeWordspotting.indexOf('groups') !== -1 &&
          this.wordspottingGroups.length > Object.keys(this.wordspotting.groups).length) {
          showForGroups = true;
        }

        return (showForUser || showForOrg || showForGroups);
      }
    },
    showGlobalDefaults: {
      cache: false,
      get() {
        return (Object.keys(this.wordspotting.global).length &&
          !this.showOrgSettings &&
          !this.showGroupSettings &&
          !this.showUserSettings);
      }
    },
    showGroupSettings: {
      cache: false,
      get() {
        return Object.keys(this.wordspotting.groups).length;
      }
    },
    showOrgSettings: {
      cache: false,
      get() {
        return Object.keys(this.wordspotting.org).length;
      }
    },
    showUserSettings: {
      cache: false,
      get() {
        return Object.keys(this.wordspotting.user).length;
      }
    },
    addCustomWordspottingButtonLabel: {
      cache: false,
      get() {
        let label = 'Add Custom Wordspotting';
        if (this.activeWordspotting.indexOf('groups') !== -1 && this.activeWordspotting.length === 1) {
          label += ' for a ';
          label += (this.orgType === 'edu') ? 'Class' : 'Group';
        }
        return label;
      }
    },
    activeWordspotting: {
      cache: false,
      get() {
        const types = [];
        const org = this.$store.getters.org;
        if (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Groups &&
          (this.isGroupManager || this.isOrgLevelAdmin)) {
          types.push('groups');
        }
        if (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Orgs &&
          this.isOrgLevelAdmin) {
          types.push('org');
        }
        if (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Users &&
          this.speakerGroups.length > 0) {
          types.push('users');
        }
        return types;
      }
    },
    orgName() {
      return this.$store.getters.org.name;
    },
  },
  methods: {
    addEmptyWord() {
      const lastWord = this.words[this.words.length - 1];
      const lastWord2 = this.words[this.words.length - 2];
      if (lastWord === '' && lastWord2 === '') {
        return; // Dont add more than 2 empty inputs
      }
      this.words.push('');
    },
    trimAndValidateTheWords() {
      const words = [];
      this.words.forEach((word) => {
        if (word && word.trim()) {
          const trimmed = word.trim();
          words.push(trimmed);
        }
      });

      this.words = words;

      if (this.words.indexOf('uh/um') === -1) {
        alert('Restoring "uh/um" to the list. This phrase cannot be removed.');
        this.words.push('uh/um');
      }

      return true; // We no longer have any failure conditions
    },
    loadCurrentWordspotting() {
      // First, try to load the exact type being requested for current algorithm
      // Then, try to load default algorithm for user, group, org then global
      const defaultAlgo = this.$store.getters.org.algorithmConfig.default_algorithm;
      if (this.groupId && this.algorithm && this.wordspotting.groups && this.wordspotting.groups[this.groupId]
        && this.wordspotting.groups[this.groupId][this.algorithm]) {
        this.words = this.wordspotting.groups[this.groupId][this.algorithm].words;
      } else if (this.formType === 'org' && this.wordspotting.org && this.wordspotting.org[this.algorithm]) {
        this.words = this.wordspotting.org[this.algorithm].words;
      } else if (this.wordspotting.user && this.wordspotting.user[this.algorithm]) {
        this.words = this.wordspotting.user[this.algorithm].words;
      } else if (this.wordspotting.global && this.wordspotting.global[this.algorithm]) {
        this.words = this.wordspotting.global[this.algorithm].words;
      } else if (this.groupId && defaultAlgo && this.wordspotting.groups && this.wordspotting.groups[this.groupId]
        && this.wordspotting.groups[this.groupId][defaultAlgo]) {
        this.words = this.wordspotting.groups[this.groupId][defaultAlgo].words;
      } else if (this.wordspotting.user && this.wordspotting.user[defaultAlgo]) {
        this.words = this.wordspotting.user[defaultAlgo].words;
      } else if (this.wordspotting.org && this.wordspotting.org[defaultAlgo]) {
        this.words = this.wordspotting.org[defaultAlgo].words;
      } else if (this.wordspotting.global && this.wordspotting.global[defaultAlgo]) {
        this.words = this.wordspotting.global[defaultAlgo].words;
      }

      this.trimAndValidateTheWords();
      this.words.push('');
      this.words.push(''); // Add 2 empty input boxes at the bottom of the form
    },
    phraseBlurred(event) {
      // Save the new word
      const index = event.target.id.replace('word', '');
      this.words[index] = event.target.value;

      // Also, add a new input every time a phrase is blurred
      this.addEmptyWord();
    },
    phraseClicked(event) {
      // Add a new input (by appending an empty string to the words array) if the currently
      // selected input is itself empty
      if (event.target.value == '') {
        this.addEmptyWord();
      }
    },
  },
};
